import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const QulityManagement = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Qulity Management', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Qulity Management" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
    <div class="container">
        <div class="row flex-xl-row flex-column-reverse">
            <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                    <div class="sidebar__widget-service mb-30">
                        <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i></Link>
                        <Link to="/pharmaceutical-details">Pharmaceutical & Biotech Industry<i class="fa-solid fa-plus"></i></Link>
                        <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i></Link>
                    </div>

                    <div class="sidebar__widget-contact__service text-center">
                        <h4 class="mb-25 title-animation text-capitalize">Are You Ready to Contact Us?</h4>
                        <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>

                        <Link to="/contact-us#" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>

            <div class="col-xl-8">
                <div class="service-details__content">
                    <div class="service-details__content-media mb-20">
                        <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="Quality Management System" />
                    </div>

                    <h2 class="title-animation mb-20">Quality Management System</h2>

                    <p class="mb-20">A well-designed and effectively implemented Quality Management System (QMS) is essential for the medical device industry. A QMS is the supporting structure of any company and typically includes all of its operations. A QMS is associated with companies with high quality, and it has many goals, the most obvious ones being consistent company operations which are compliant with applicable standards and regulations. It not only ensures compliance with regulatory requirements but also drives product quality, customer satisfaction, and business success. By focusing on key components and fostering a quality-centric culture, medical device companies can navigate the complex regulatory landscape and deliver safe, effective products to market.</p>

                    <h3 class="title-animation mb-10">SQUARE MEDTECH Expertise in Quality Management System</h3>
                    <p class="mb-30">SQUARE MEDTECH experts provide assistance in building and managing quality management systems.</p>

                    <h3 class="title-animation mb-10">How SQUARE MEDTECH Can Help in QMS:</h3>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span>Identifying changes that require QMS updates</li>
                        <li><span><i class="fa-solid fa-check"></i></span>Conducting a systematic GAP analysis for existing QMS processes in relation to these changes against regulatory standards such as: MDD versus MDR, ISO 13485 versus MDR, ISO 13485 and ISO 9001 standard version changes, ISO 13485 versus US FDA 21 CFR Title 820 (QSR), ISO 14971 standard version changes and other relevant guidelines.</li>
                        <li><span><i class="fa-solid fa-check"></i></span>Assisting the manufacturer in interpreting the gap analysis and addressing the identified gaps in their QMS</li>
                        <li><span><i class="fa-solid fa-check"></i></span>Performing GAP analyses for medical device technical documentation</li>
                        <li><span><i class="fa-solid fa-check"></i></span>Support internal audit of QMS for your organization</li>
                        <li><span><i class="fa-solid fa-check"></i></span>Planning & implementing a new QMS</li>
                    </ul>

                    <div class="row">
                        <div class="col-lg-7">
                            <div class="service-details__content-media-item service-details__content-media-item-1">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="QMS Solutions" />
                                </div>
                                <h4 class="title-animation mb-15">Comprehensive QMS Solutions</h4>
                                <p>SQUARE MEDTECH's comprehensive approach ensures your Quality Management System is robust, compliant, and tailored to your organization's needs, supporting efficiency and regulatory success.</p>
                            </div>
                        </div>

                        <div class="col-lg-5">
                            <div class="service-details__content-media-item service-details__content-media-item-2">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="Expert Guidance" />
                                </div>
                                <h4 class="title-animation mb-15">Expert Guidance</h4>
                                <p>Our team of experts collaborates closely with your organization to deliver strategic QMS solutions, ensuring continuous improvement and sustainable business growth.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">QMS & Gap Identification Services: </h4>
                        <ul  class="color-white mb-0">
                        <li>Planning & implementing</li>
                        <li>Methodical approach in QMS</li>
                        <li>Updating QMS when corrective & preventative actions required</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">QMS & Gap Identification Services:  </h4>
                        <ul  class="color-white mb-0">
                        <li>Internal audit Support</li>
                        <li>Systematic GAP analysis</li>
                        <li>Support when Regulatory changes</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
